@if(showPopup) {
  <section role="dialog" aria-modal="true" aria-labelledby="payment-summary-title"
    class="py-[2rem] sm:gap-[1rem] gap-[3rem] sm:w-[60rem] w-[66rem] flex flex-col items-center justify-center bg-white">
    <h2 mat-dialog-title id="payment-summary-title" class="!min-h-fit">
      {{"OFFER_PAYMENT_POPUP_LABEL" | translate}}
    </h2>
    <mat-dialog-content class="!max-h-none !overflow-visible max-sm:!h-[60vh] max-sm:!max-h-[60vh] max-sm:!overflow-y-auto !m-0 !p-0 !w-full">
      <div class="!max-h-none !m-0 !p-0 w-full gap-4 flex flex-col items-center h-full">
        <div class="flex flex-col px-[5rem] w-full h-[15rem]">
          <table class="w-full h-full dsr-typescale-body-small border-collapse p-0 border" role="table"
            aria-labelledby="payment-summary-caption">
            <caption id="payment-summary-caption" class="sr-only">
              Payment summary breakdown
            </caption>
            <tbody>
              <tr class="max-sm:py-[4rem]">
                <th scope="row" class="text-left p-[1rem]">
                  {{ "HT" | translate }}:
                </th>
                <td class="text-center">{{ data.priceHTC }} €</td>
              </tr>
              <tr class="bg-gray-100 max-sm:py-[4rem]">
                <th scope="row" class="text-left p-[1rem]">
                  {{ "VAT_PERT" | translate }}({{ data.vatPercent }}%):
                </th>
                <td class="text-center">{{ data.priceVAT }} €</td>
              </tr>
              <tr class="max-sm:py-[4rem]">
                <th scope="row" class="text-left p-[1rem] font-bold">
                  {{ "TTC" | translate }}:
                </th>
                <td class="text-center dsr-typescale-body-small-prominent">
                  {{ data.priceTTC }} €
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-justify px-[5rem] w-full hidden sm:block !leading-[16px]">
          <span class="dsr-typescale-body-small text-justify required-label !leading-[16px] !py-[5px]"
            style="display: inline-block">{{ "USER_INFORMATION_NOTE_1" | translate }}</span>
          <span class="dsr-typescale-body-small text-justify required-label !leading-[16px] !py-[5px]"
            style="display: inline-block">{{ "USER_INFORMATION_NOTE_3" | translate }}</span>
          <span class="dsr-typescale-body-small text-justify required-label !leading-[16px] !py-[5px]"
            style="display: inline-block">{{ "USER_INFORMATION_NOTE_2" | translate }}</span>
          <span class="dsr-typescale-body-small text-justify !leading-[16px]  !pb-[10px] !pt-[5px]"
            style="display: inline-block">
            <input type="checkbox" [(ngModel)]="purchaseInfo" id="purchaseInfo" name="purchaseInfo" />
              &nbsp; {{ "PURCHASE_INFORMATION_NOTE" | translate }}
          </span>
          <span class="dsr-typescale-body-small text-justify !leading-[16px] !py-[5px]">
            <input type="checkbox" [(ngModel)]="termsConditions" id="termsConditions" name="termsConditions" />
              &nbsp; {{ "TERMS_AND_CONDITIONS_CONFIRMATION" | translate }}
          </span>
          <a class="!text-[14px] !font-bold !border-dotted !border-b-2 border-b-gray-300"
            [href]="tcDoc" target="_blank" rel="noopener noreferrer"> 
            {{ "TERMS_AND_CONDITIONS" | translate }}</a>
        </div>
        <div class="text-justify px-[5rem] !mt-14 w-full sm:hidden !leading-[16px]">
          <span class="dsr-typescale-label-small text-justify required-label !leading-[16px] !py-[5px]"
            style="display: inline-block">{{"USER_INFORMATION_NOTE_1" | translate }}</span>
          <span class="dsr-typescale-body-small text-justify required-label !leading-[16px] !py-[5px]"
            style="display: inline-block">{{"USER_INFORMATION_NOTE_3" | translate }}</span>
          <span class="dsr-typescale-label-small text-justify required-label !leading-[16px] !py-[5px]"
            style="display: inline-block">{{"USER_INFORMATION_NOTE_2" | translate }}</span>
          <span class="dsr-typescale-label-small text-justify !leading-[16px] !pb-[10px] !pt-[5px]"
            style="display: inline-block">
            <input type="checkbox" [(ngModel)]="purchaseInfo" id="purchaseInfo" name="purchaseInfo" />
              &nbsp; {{ "PURCHASE_INFORMATION_NOTE" | translate }}
          </span>
          <span class="dsr-typescale-label-small text-justify !leading-[16px] !py-[5px]" style="display: inline-block">
            <input type="checkbox" [(ngModel)]="termsConditions" id="termsConditions" name="termsConditions" />
              &nbsp; {{ "TERMS_AND_CONDITIONS_CONFIRMATION" | translate }}
          </span>
          <a class="dsr-typescale-label-small !font-bold !underline !border-dotted !border-b-2 border-b-gray-300"
            [href]="tcDoc" target="_blank" rel="noopener noreferrer">{{ "TERMS_AND_CONDITIONS" | translate }}</a>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions role="group" aria-label="Payment confirmation actions" 
      class="!min-h-fit !m-0 !p-0 flex gap-[1.6rem] font-[600] text-[1.6rem]">
      <button mat-flat-button [disabled]="!purchaseInfo || !termsConditions" class="" (click)="confirmPay()" type="button"
        [attr.aria-busy]="!purchaseInfo || !termsConditions"><span class="">{{ "CONFIRM_BUTTON" | translate }}</span>
      </button>
      <button mat-stroked-button color="primary" (click)="cancelPay()" class="" type="button" aria-label="Cancel payment">
        <span class="">{{ "CANCEL_BUTTON" | translate }}</span>
      </button>
    </mat-dialog-actions>
  </section>
}